import { useGetCountriesDataQuery } from "store/apis/onboarding";
import { QuestionOption } from "v2/constants/taxSetupQuestions";

const EMPTY_OPTIONS: QuestionOption[] = [];

export const useCountryOptions = (): QuestionOption[] => {
  const { data: countries } = useGetCountriesDataQuery();

  if (!countries) return EMPTY_OPTIONS;

  return countries.map((country) => ({
    label: country.name,
    value: country.uuid,
  }));
};
